import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    zoomStep: { type: Number, default: 0.2 },
    minZoom: { type: Number, default: 0.1 },
    maxZoom: { type: Number, default: 5 }
  }

  disconnect() {
    this.cleanup()
  }

  // Methods to be implemented by subclasses
  initializeViewer() {
    throw new Error('initializeViewer() must be implemented by subclass')
  }

  destroyViewer() {
    throw new Error('destroyViewer() must be implemented by subclass')
  }

  zoomIn() {
    throw new Error('zoomIn() must be implemented by subclass')
  }

  zoomOut() {
    throw new Error('zoomOut() must be implemented by subclass')
  }

  cleanup() {
    // Can be overridden by subclasses for additional cleanup
  }

  handleError(message) {
    console.error(message)
    this.dispatch('error', { detail: { message } })

    if (!this.errorElement) {
      this.errorElement = document.createElement('div')
      this.errorElement.className = 'text-accent-red p-3'
      this.element.prepend(this.errorElement)
    }
    this.errorElement.textContent = message
  }

  hideError() {
    if (this.errorElement) {
      this.errorElement.remove()
      this.errorElement = null
    }
  }
}
